var Video;
(function (Video) {
    const $videos = document.querySelectorAll('.video');
    if ($videos.length) {
        $videos.forEach(($video) => {
            let videoCover = $video.querySelector('.video-cover');
            let videoFrame = $video.querySelector('.video-frame');
            if (videoCover) {
                const playVideo = () => {
                    if (!(videoCover === null || videoCover === void 0 ? void 0 : videoCover.classList.contains('hidden'))) {
                        videoCover.className += ' hidden';
                    }
                };
                videoCover.addEventListener('click', playVideo);
            }
        });
    }
    var imgElement = document.getElementById('img-box-src');
    var deskImgInput = document.getElementsByName('desk-img')[0];
    var mobImgInput = document.getElementsByName('mob-img')[0];
    function checkScreenSize() {
        var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var isMobile = screenWidth < 768;
        if (isMobile) {
            imgElement.src = mobImgInput === null || mobImgInput === void 0 ? void 0 : mobImgInput.value;
        }
        else {
            imgElement.src = deskImgInput === null || deskImgInput === void 0 ? void 0 : deskImgInput.value;
        }
    }
    function handleResize() {
        checkScreenSize();
    }
    if (imgElement) {
        window.addEventListener('resize', handleResize);
        handleResize();
    }
    const iframes = document.getElementsByTagName('iframe');
    for (const iframe of iframes) {
        const srcValue = iframe.getAttribute('src');
        const lastIndex = srcValue === null || srcValue === void 0 ? void 0 : srcValue.lastIndexOf('/');
        const trimmedURL = srcValue === null || srcValue === void 0 ? void 0 : srcValue.substring(lastIndex + 1);
        if (trimmedURL) {
            iframe.setAttribute('aria-label', trimmedURL);
        }
    }
})(Video || (Video = {}));
